import _ from "lodash";
import store from "services/redux/store";
import { addDataByGuid } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchBuilding from "utils/fetch/FetchBuilding";

export default class FetchCachedBuilding
{
	static logName = 'FetchCachedBuilding';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'buildings',
				tables: [ 'office_building' ],
				onExpire: this.reload,
				updated_at_max_age: ( 5 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};

	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
				onFresh: () => {
					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess( this.values )
					}
				},
				onExpired: () => {
					this.reload( {callbackSuccess, callbackError, callbackStart} )
				}
		})
			);
		});
	}

	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchBuilding.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( buildings ) => {
						// Save to object
						this.process( buildings );

						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, buildings, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess( buildings );
						}
					}
				})
			);
		}
		);
	}

	static process = ( buildings ) => {
		this.values = buildings;
		
		store.dispatch( addDataByGuid( dataConstants.BUILDINGS, this.values ) );
	}
}
